import { render, staticRenderFns } from "./News.vue?vue&type=template&id=7371f512&scoped=true"
import script from "./News.js?vue&type=script&lang=js&external"
export * from "./News.js?vue&type=script&lang=js&external"
import style0 from "./News.scss?vue&type=style&index=0&id=7371f512&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7371f512",
  null
  
)

export default component.exports